/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { computed, autorun } from "mobx";

let disposers = [];

export const unsubscribeFromSelectors = () => {
  disposers.forEach(disposer => {
    if (disposer && typeof disposer === "function") disposer();
  });
  disposers = [];
};

export const subscribeToSelector = (
  stores,
  selector,
  callback,
  valueDidUpdate = (oldVal, newVal) => oldVal !== newVal,
  ...args
) => {
  const computedSelector = computed(() => selector(stores, ...args));
  let oldComputedValue = computedSelector.get();
  let isFirstRun = true;
  const disposer = autorun(reaction => {
    const newComputedValue = computedSelector.get();
    if (valueDidUpdate(oldComputedValue, newComputedValue) || isFirstRun) {
      isFirstRun = false;
      oldComputedValue = newComputedValue;
      callback(newComputedValue, reaction);
    }
  });

  disposers.push(disposer);
  return disposer;
};
